import {
  GET_COMMON_DASHBOARD,
  SET_COMMON_DASHBOARD_APPS,
  ADD_APP_FAV,
  SET_ADD_APP_FAV,
  SET_LOADING,
  GET_NEWS_AND_ANNOUNCEMENT,
  SET_NEWS_AND_ANNOUNCEMENT,
  TOGGLE_ATTACHMENTS_LOADING,
  SET_ATTACHMENTS,
  UPLOAD_ATTACHMENTS,
  REMOVE_ATTACHMENT,
  GLOBAL_LOADER_TEXT,
} from "./types";

const getCommonDashboard = (user: any) => {
  return {
    type: GET_COMMON_DASHBOARD,
    user,
  };
};

const setCommonDashboardApps = (value: any) => {
  return {
    type: SET_COMMON_DASHBOARD_APPS,
    value,
  };
};

const addFavoriteApp = (favApp: any) => {
  return {
    type: ADD_APP_FAV,
    favApp,
  };
};

const setAddFavApp = (value: boolean) => {
  return {
    type: SET_ADD_APP_FAV,
    value,
  };
};

const setLoading = (value: boolean) => {
  return {
    type: SET_LOADING,
    value,
  };
};
const getNewsAndAnnouncementDetails = (reqBody: any) => {
  return {
    type: GET_NEWS_AND_ANNOUNCEMENT,
    reqBody,
  };
};

const setNewsAndAnnouncementDetails = (value: any) => {
  return {
    type: SET_NEWS_AND_ANNOUNCEMENT,
    value,
  };
};

const toggleAttachmentsLoading = (value: any) => ({
  type: TOGGLE_ATTACHMENTS_LOADING,
  value,
});

const setAttachments = (value: any) => ({
  type: SET_ATTACHMENTS,
  value,
});

const uploadAttachments = (obj: any) => ({
  type: UPLOAD_ATTACHMENTS,
  obj,
});

const removeAttachment = (value: any) => ({
  type: REMOVE_ATTACHMENT,
  value,
});

const globalLoaderText = (text: string) => ({
  type: GLOBAL_LOADER_TEXT,
  payload: text
});

export {
  getCommonDashboard,
  setCommonDashboardApps,
  addFavoriteApp,
  setAddFavApp,
  setLoading,
  getNewsAndAnnouncementDetails,
  setNewsAndAnnouncementDetails,
  toggleAttachmentsLoading,
  setAttachments,
  uploadAttachments,
  removeAttachment,
  globalLoaderText,
};
